import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Icon } from 'antd';
const FormItem = Form.Item;
// import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
// import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
import { Button, Badge, Tooltip } from 'antd';
import { SgiEventHandler } from './SgiEventHandler'
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { addCtnCommonAttribute } from '../sgiComp/SgiCtnComm';
import { testReactVsn } from './sgiBaseComp/SgiCommon';
import { uuid } from 'rt-sd-common';
import { toCallSi } from './SgiCompComm'

class SgiButton extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state
        this.state = {
            tooltiProps: {},
            text: undefined,
            inputprops: {
                style: { marginRight: '5px' },
                disabled: false //是否可用
            },
            badgeProps: {
                isExist: false,
                style: {}
            },
            functions: {},
            loading: false,
            isHref: false
        };
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    button_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        // var formItemProps = { style: {} }; //input外层属性
        // var inputprops = { style: {} }; //转换后属性
        //添加公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.inputprops)
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.inputprops, this.state.tooltiProps, this.state.badgeProps);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.inputprops, this.state.functions, type, objFct);
    }
    quertEvent(moduleDesc, objFct) {

        let compIdArr = moduleDesc.compId ? moduleDesc.compId.split(',') : [];//刷新组件id
        let serviceUrl = moduleDesc.serviceUrl;//服务地址变量字符穿
        let resObjArr = moduleDesc.resObj ? moduleDesc.resObj.split(',') : [];//返回结果实例名


        let req = {};//查询条件
        var clkBefLsn = moduleDesc.clkBefLsn; // 用户自定义点击前处理事件
        if (clkBefLsn) {
            let $clkBefLsn = new Function("module", "objFct", clkBefLsn);
            let clkBefLsnRes = $clkBefLsn(moduleDesc, objFct)

            if (Object.prototype.toString.call(clkBefLsnRes) === '[object Object]') {
                Object.assign(req, clkBefLsnRes)
            }
        }



        if (moduleDesc.isPartial) {//是否分批
            tool.tableBatchSelect(compId, objFct, eval(serviceUrl), req, function (res) {
                if (res && res.head && res.head.code === "0000") {
                    tool.sgiLogger.info("查询成功 res :", res);

                    var clkMidLsn = moduleDesc.clkMidLsn; // 用户自定义点击中处理事件
                    if (clkMidLsn) {
                        let $clkMidLsn = new Function("module", "objFct", "response", clkMidLsn);
                        $clkMidLsn(moduleDesc, objFct, res);
                        compIdArr.forEach(element => {
                            tool.refreshTable(element, objFct);
                        })
                    } else {
                        resObjArr.forEach(element => {
                            objFct.set(element, res.body);
                        })
                        compIdArr.forEach(element => {
                            tool.refreshTable(element, objFct);
                        })
                    }

                } else {
                    tool.sgiLogger.error("查询失败 res :", res);
                }
            }, moduleDesc.isAsyn ? true : false);
        } else {
            commonClient.simplecall(eval(serviceUrl), req, function (res) {
                if (res && res.head && res.head.code === "0000") {
                    tool.sgiLogger.info("操作成功 res :", res);

                    var clkMidLsn = moduleDesc.clkMidLsn; // 用户自定义点击中处理事件
                    if (clkMidLsn) {
                        let $clkMidLsn = new Function("module", "objFct", "response", clkMidLsn);
                        $clkMidLsn(moduleDesc, objFct, res);
                        compIdArr.forEach(element => {
                            tool.refreshTable(element, objFct);
                            tool.refreshWV(element, objFct)
                        })
                    } else {
                        resObjArr.forEach(element => {
                            objFct.set(element, res.body);
                        })
                        compIdArr.forEach(element => {
                            tool.refreshTable(element, objFct);
                            tool.refreshWV(element, objFct)
                        })
                    }

                } else {
                    tool.sgiLogger.error("操作失败 res :", res);

                }
            }, moduleDesc.isAsyn ? true : false);
        }


    }
    /**
     * 按钮默认查询事件
     * @param {*} moduleDesc 
     * @param {*} objFct 
     */
    btnDefaultEvent(moduleDesc, objFct) {
        if (!moduleDesc) {
            return
        }

        let serviceUrl = moduleDesc.serviceUrl;//查询服务地址
        if (serviceUrl) {
            this.quertEvent(moduleDesc, objFct);
        }



        var clkLsn = moduleDesc.clkLsn; // 用户自定义点击后处理事件/点击事件
        if (clkLsn) {
            let $clkLsn = new Function("module", "objFct", clkLsn);
            $clkLsn(moduleDesc, objFct)
        }

    }

    /**
     * 绑定事件
     * @param {*} moduleDesc 
     * @param {*} formProps 
     */
    bindEvent(moduleDesc, formProps, functions, type, objFct) {
        //拖拽模式 不生成事件
        if (type == 'dnd') {
            return;
        }

        // functions.onClick = this.btnDefaultEvent.bind(this, moduleDesc, objFct);
        let btnType = moduleDesc.btnType;
        if (btnType && btnType == "callSI") {
            // 服务调用
            functions.onClick = this.btnOnClick.bind(this, moduleDesc, objFct);
        } else {
            // 普通按钮-自定义点击事件
            let clkLsn = moduleDesc.clkLsn;
            if (clkLsn) {
                let $clkLsn = new Function("module", "objFct", clkLsn);
                functions.onClick = $clkLsn;
            }
        }
        formProps.onClick = SgiEventHandler.onClick.bind(this);
    }

    btnOnClick(moduleDesc, objFct) {
        toCallSi(moduleDesc, objFct)
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, inputprops, tooltiProps, badgeProps) {
        //csstyle 样式文件这个我还不知道怎么用
        var csstyle = moduleDesc.csstyle;
        if (csstyle == 'button-primary') {
            inputprops.type = 'primary'
        } else if (csstyle == 'button-auxiliary') {
            inputprops.type = 'dashed'
        } else if (csstyle == 'button-danger') {
            inputprops.type = 'danger'
        }

        //右上角标 ??未完全实现
        var badgeText = moduleDesc.badgeText;
        if (badgeText) {
            badgeProps.isExist = true;
            badgeProps.count = badgeText;
        }

        // 是否链接样式
        const isHref = moduleDesc.isHref;
        this.state.isHref = !!isHref;
        if (isHref) {//对链接样式进行一定修改
            inputprops.style.color = "#1890ff";
            inputprops.style.marginRight = "10px";
        }

        //显示边框 ??
        var isBrdr = moduleDesc.isBrdr;
        //边框宽度 ??未实现
        var bdrW = moduleDesc.bdrW;

        //背景图片 ??未实现
        var bkImgPh = moduleDesc.bkImgPh;

        //背景图重复方式 ??未实现
        var bkImgRptType = moduleDesc.bkImgPbkImgRptTypeh;

        var btnIconPh = moduleDesc.btnIconPh;//按钮图标
        if (btnIconPh) inputprops.icon = btnIconPh;

        //按钮图片位置 ??未实现,如果想控制 Icon 具体的位置，只能直接使用 Icon 组件，而非 icon 属性
        var iconAlg = moduleDesc.iconAlg;

        //按钮的提示信息
        var hvInfo = moduleDesc.hvInfo;
        if (hvInfo) {
            tooltiProps.title = hvInfo;
            // tooltiProps.defaultVisible = false;//默认就是false
        } else {
            // tooltiProps.defaultVisible = true;//这是什么操作???
        }

        //文本位置 ??
        var teAl = moduleDesc.teAl;

        //显示名称
        var te = inputprops.te;//公共属性中从资源文件获取
        /**if (te)*/ this.state.text = te;

        var isDis = moduleDesc.isDis; //是否可用
        if (isDis) {
            inputprops.disabled = true;
        } else {
            inputprops.disabled = false;
        }
    }

    /**
   * 设置是否隐藏
   */
    setHidden(value) {
        // this.state.inputprops.hidden = value; //2018.04.25-yly,修改弹窗无法隐藏问题
        // this.setState(this.state.inputprops);
        if (value) {
            this.state.tooltiProps.style = { display: "none" }
            this.state.inputprops.style.display = "none";
            this.state.badgeProps.style.display = "none";
        } else {
            this.state.tooltiProps.style = { display: undefined };
            this.state.inputprops.style.display = undefined;
            this.state.badgeProps.style.display = undefined;
        }
        if (testReactVsn(this, 16)) {
            // 更新引用
            this.state.inputprops.style = { ...this.state.inputprops.style };
            this.state.badgeProps.style = { ...this.state.badgeProps.style };
            this.state.inputprops.key = uuid(8);
        }
        this.setState({ loading: false });
    }

    setDisabled(value) {
        if (this.state.inputprops.disabled === value) {
            return;
        }
        this.state.inputprops.disabled = value;
        this.setState(this.state.inputprops);
    }

    setText(value) {
        if (this.state.text === value) {
            return;
        }
        this.state.text = value;
        this.setState({ loading: false });
    }

    setBadge(badge) {
        if (typeof badge === "object") {
            Object.assign(this.state.badgeProps, badge);
        } else {
            this.state.badgeProps.isExist = true;
            this.state.badgeProps.count = badge;
        }
        this.setState({ loading: false });
    }

    setType(value) {
        if (this.state.inputprops.type === value) {
            return;
        }
        this.state.inputprops.type = value;
        this.setState({ loading: false });
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性
            this.button_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        let btn;
        if (this.state.isHref) {
            btn = <a {...this.state.inputprops}>{this.state.text}</a>;
        } else if (this.props.moduleDesc.isOnlyImg && this.state.inputprops.icon) {
            btn = <Icon {...this.state.inputprops} type={this.state.inputprops.icon} />
        } else {
            btn = <Button {...this.state.inputprops}>{this.state.text}</Button>;
        }

        return (
            <Tooltip {...this.state.tooltiProps}>
                {this.state.badgeProps.isExist ?
                    <Badge {...this.state.badgeProps}>
                        {btn}
                    </Badge>
                    :
                    btn
                }
            </Tooltip>
        );
    }
}

//给类添加公共方法
// Object.assign(SgiFormButton.prototype, sgiFormCtlBaseFun);

export { SgiButton };
export default SgiButton;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiButton.js